<template>
  <label class="b-contain">
    <span class="pa2" :id="'option_' + value">{{ label }}</span>
    <input type="checkbox"
      :name="name"
      :value="value"
      :checked="checked" indeterminate="true"
      @change="$emit('change', { checked: $event.target.checked, value: $event.target.value, name: name })">
    <div class="b-input"></div>
  </label>
</template>

<script>
export default {
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: ['name', 'value', 'checked', 'label']
}
</script>

<style lang="scss" scoped>
</style>
